import axios from 'axios';

const host = process.env.VUE_APP_API_HOST;

const moduleEvents = {
    namespaced: true,
    state: () => ({
        events: [],
    }),
    getters: {
        events: state => {
            return state.events;
        },
    },
    mutations: {
        /**
         * Set the state events
         * @param {object} state The state of the Vuex Store
         * @param {object} events The new value for events
         */
        setEvents (state, {events}) {
            state.events = events;
        },
    },
    actions: {
        /**
         * Calls the Events@update api, and fill the state events 
         * @param {object} context Exposes the same set of methods/properties on the store instance
         * @return {Promise<object>}
         */
        fetchEvents (context, {startDate, endDate}) {
            return new Promise((resolve, reject) => {
                let url = host + '/api/v1/events?date[gte]=' + startDate + '&date[lte]=' + endDate;
                axios.get(url).then((response) => {
                    context.commit('setEvents', {'events': response.data});
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    }
}
export default moduleEvents;